import { render } from "./SideActions.vue?vue&type=template&id=5abf9e12"
import script from "./SideActions.vue?vue&type=script&lang=js"
export * from "./SideActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__